<template>
  <section class="sidebar-item-list">
    <ul class="nav-list" :class="{ side: side_nav }">
      <li
        :class="{ active: c === item }"
        v-for="c in configs"
        :key="c.name"
        @click="set_active(c.id)"
        :title="c.name"
      >
        {{ c.name | removeUnderscores }}
      </li>
    </ul>
    <!-- <h3>{{ item.name | removeUnderscores }}</h3> -->
    <div class="title-wrapper">
      <img class="icon-holder" src="../../assets/star-Icon.png">
      <h3> INDICATES UPGRADE</h3>
    </div>
    <template v-if="!item.isMultiple">
      <Materials
        :sidebar="side_nav"
        :item="item"
        :disabled="false"
        :configuratorName="configurator.name"
        @onClickCombination="change_combination"
      />
    </template>
    <template v-else>
      <Materials
        :sidebar="side_nav"
        :item="item"
        :disabled="true"
        :configuratorName="configurator.name"
        @onClickCombination="add_overlay_item"
      />
    </template>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { generate_map_link } from '@/lib/helpers';
import Materials from './Materials';

export default {
  name: 'SidebarItemsList',
  filters: {
    removeUnderscores(text) {
      return text.replace(/_/gi, ' ');
    },
    getThumbnail(mat_name, mat_block, config_name) {
      return generate_map_link(config_name, mat_block, mat_name);
    },
  },
  components: {
    Materials,
  },
  computed: {
    ...mapGetters({
      item: 'active_set',
      configurator: 'configurator',
      type: 'type',
    }),
    configs() {
      return this.configurator.configs;
    },
    side_nav() {
      return this.configurator.configs.length > 3 ? true : false;
    },
  },
  methods: {
    set_active(id) {
      if (id === this.item.id) return false;
      this.$store.dispatch('set_active', id);
    },
    change_combination(id, material_id, multiple, overlay) {
      this.$store.dispatch('change_combination', { id, material_id, overlay });
    },
    add_overlay_item(id, material_id, multiple, isactive) {
      this.$store.dispatch('add_overlay_item', {
        id,
        material_id,
        multiple,
        isactive,
      });
    },
  },
};
</script>
